/** Iterates the arrays (undefined is coalesced to []), and return all values that are found in only one array */
export function arrayExclusive<T>(a: T[] | undefined, b: T[] | undefined): T[] {
  a ??= [];
  b ??= [];
  const output: T[] = [];

  /** Push values from either list that don't appear in the other */
  for (const value of a) if (!b.includes(value)) output.push(value);
  for (const value of b) if (!a.includes(value)) output.push(value);

  return output;
}
